import React from "react";
import {
  Button, Checkbox, Dialog, DialogTitle, DialogContent,
  FormControlLabel, Stack, Typography,
} from "@mui/material";

/* global gtag */

export function ShareDialog({
  open,
  onClose,
  includeSpoilers,
  onToggleSpoilers,
  onSMSShare,
  onWhatsAppShare,
  onBlueskyShare,
  onClipboardCopy,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ marginBottom: 2, fontSize: "20px", fontFamily: "'Montserrat'", fontWeight: "bold" }}>
        <span style={{ marginRight: "10px" }}>📤</span>Share your Reely
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ marginBottom: 2, fontSize: "14px", fontFamily: "'Montserrat'" }}>
          Choose how you'd like to share:
        </Typography>
        <Stack spacing={2}>
          <Button variant="contained" onClick={onSMSShare}>📱 Messages</Button>
          <Button variant="contained" onClick={onWhatsAppShare}>🟢 WhatsApp</Button>
          <Button variant="contained" onClick={onBlueskyShare}>🦋 Bluesky</Button>
          <Button variant="contained" onClick={onClipboardCopy}>📋 Copy to Clipboard</Button>
        </Stack>
        <FormControlLabel
          control={
            <Checkbox
              checked={includeSpoilers}
              onChange={(e) => {
                onToggleSpoilers(e.target.checked);
                if (typeof gtag === "function") {
                  gtag("event", "toggle_include_spoilers", {
                    event_category: "Engagement",
                    event_label: e.target.checked ? "Enabled Spoilers" : "Disabled Spoilers",
                  });
                }
              }}
              color="primary"
            />
          }
          label={
            <Typography sx={{ fontSize: "12px", fontFamily: "'Montserrat'", marginLeft: 1 }}>
              Include your reel (spoiler alert!)
            </Typography>
          }
          sx={{ marginTop: 2 }}
        />
      </DialogContent>
    </Dialog>
  );
}
